export default __webpack_public_path__ + "static/media/cny-lucky-draw.e8adf389.webp";